module.exports = __webpack_public_path__ + "img/intro17.3d1b2eaa.jpg";